import { notification } from "antd";

function notificationError(description, duration = 6) {
  notification.error({
    message: "Oops! something went wrong",
    description: description,
    duration,
  });
}
function notificationSuccess(description, duration = 6) {
  notification.success({
    message: "Success",
    description: description,
    duration,
  });
}
function formatNumbers(number) {
  const formattedNumber = Number(number)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return formattedNumber;
}

function convertToCapitalize(sentence) {
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}

function slugify(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "_")
    .replace(/^-+|-+$/g, "");
}

const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString.replace(" ", "T"));

  if (isNaN(date.getTime())) return "N/A";

  const day = date.getDate();

  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th";

    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  const time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <>
      {day}
      {getOrdinal(day)} {month} {year}
      <br />
      {time.toLowerCase()}
    </>
  );
};

export {
  notificationError,
  notificationSuccess,
  formatNumbers,
  convertToCapitalize,
  slugify,
  formatDateTime,
};
